// extracted by mini-css-extract-plugin
module.exports = {"container":"FooterSnsLink_container__1FwL1","item":"FooterSnsLink_item__PW3kH","icon":"FooterSnsLink_icon__mO-2i","sending":"FooterSnsLink_sending__aqe0_"};